import {
  faEllipsisVertical,
  faPlus,
  faFileImport,
  faFileExport,
  faFileCsv,
  faUser,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Dropdown, Nav, Container, Table } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { useGetRequest } from "../../Utils/hooks/QueryHandler"
import useLocalStorageState from "use-local-storage-state"
import { UpgradePlan } from "../../pages/UpgradePlan"
import {
  DeleteRequest,
  GetRequest,
  PutRequest,
} from "../../Utils/hooks/ApiHandler"
import DeleteModal from "../DeleteModal"
import { toast } from "sonner"
import { useEffect, useRef, useState } from "react"
import { Pagination } from "../../pages/Pagination"
import {
  formatDate,
  handleExportData,
} from "../../Utils/helpers/commonhelper"
import { Filter } from "../../pages/Filter"
import { FilterPagination } from "../../pages/FIlterPagination"
import { DropdownItemWithActions } from "../../pages/DropdownItemWithActions"
import nodata from "../../Utils/assets/img/leads_no_data_found_removebg.png"
import { TableSkeleton } from './../../Utils/skeletonLoader/TableSkeleton';
import { AuthorizationCard } from "../../pages/AuthorizationCard"
import { ColumnConfigurator } from "../../pages/ColumnConfigurator"
import useCommonData from "../../Utils/actions/advanceFilteringAction"
import { ManageListDropdown } from "../../pages/ManageListDropdown"

export const PurchaseOrder = () => {
  const navigate = useNavigate()

  const [customer, setCustomer] = useLocalStorageState("customer")
  const customerId = customer?.customer_details?.customer_id
  const loginUserId = customer?.customer_details?.id
  const token = customer?.token?.authorization
  const rf = customer?.token?.authentication

  const headers = {
    Authentication: rf,
    Authorization: token,
  }

  const extras = {
    customer,
    setCustomer,
    rf,
    navigate,
  }

  const customer_id = customer?.customer_details?.customer_id
  const [currData, setCurrData] = useState(null)
  // const [currDataHeading, setCurrDataHeading] = useState("all_purchase_orders")

  const [isMyApproval, setMyApproval] = useState(false)
  // pagination states
  // const [offset, setOffset] = useState(0)
  const [allOffset, setAllOffset] = useState(0)
  const [myApprovalOffset, setMyApprovalOffset] = useState(0)

  const activeOffset = isMyApproval ? myApprovalOffset : allOffset
  const setActiveOffset = isMyApproval ? setMyApprovalOffset : setAllOffset

  const [limit, setLimit] = useState(25)
  const [total_count, setTotalCount] = useState(0)
  const [search, setSearch] = useState("")
  const [inputSearch, setInputSearch] = useState("")
  // delete modal loading state
  const [loading, setLoading] = useState(false)

  const params = {
    limit,
    offset: activeOffset,
    search,
  }

  // states to store the filter data
  const [filterStates, setFilterState] = useState([])

  // state for heading to display
  const lastHeading = localStorage.getItem("purchase_last_heading")
  const [heading, setHeading] = useState("All Purchase Orders")
  // filter state to see the temoporary applied filter data,
  const [tempFilterData, setTempFilterData] = useState(null)
  // state for filter dropdown of quotations
  const [filterDropdown, setFilterDropdown] = useState(false)

  // for dropdown of the filter cards being created by the user
  const [filterCategoriesDropdown, setFilterCategoriesDrop] = useState(false)
  const filterCategoriesDropRef = useRef(null)

  // filter categories to render within the heading dropdown
  const [filterCategories, setFilterCategories] = useState([])
  // filter seazrch bar input state
  const [filterSearchInput, setFilterSearchInput] = useState("")
  // Add states for filter pagination and search
  const [filterOffset, setFilterOffset] = useState(0)
  const [filterLimit, setFilterLimit] = useState(5)
  const [debouncedFilterSearch, setDebouncedFilterSearch] = useState("")
  const [filterPageCount, setFilterPageCount] = useState(0)
  // isediting state for undoing the edit state in the filter name update in the heading dropdown
  const [editingId, setEditingId] = useState(false)
  useEffect(() => {
    if (!filterSearchInput || filterSearchInput.trim() === "") {
      // If no search input, show all categories
      setFilteredCategories(filterCategories)
    } else {
      // Filter categories based on search input
      const filtered = filterCategories.filter((category) =>
        category.card_name
          .toLowerCase()
          .includes(filterSearchInput.toLowerCase())
      )
      setFilteredCategories(filtered)
    }
  }, [filterSearchInput, filterCategories])
  // fitered categories to store the search input filter categories
  const [filteredCategories, setFilteredCategories] = useState([])

  // filter state to store the data to pass to delete and edit handler for filter
  const [filterData, setFilterData] = useState(null)
  // edit value state fot the filter card name edit
  const [editValue, setEditValue] = useState()
  // delete state for filter
  const [confirmFilterDelete, setFilterDelete] = useState(false)

  // checking and validating if the last selected filter still exist until then the state initialized would be false and no data or the heading would be renderd
  const [isInitialized, setIsInitialized] = useState(false)
  const [approvalCount, setApprovalCount] = useState(0)


  useEffect(() => {
    if (filterCategories?.length > 0 && !isInitialized) {
      const lastHeading = localStorage.getItem("purchase_last_heading")
      const existingFilter = filterCategories.find(
        (filter) => filter.card_name === lastHeading
      )
      setHeading(existingFilter ? lastHeading : "All Purchase Orders")
      setIsInitialized(true)
    }
  }, [filterCategories, isInitialized])


  // permission setup for purchase order
  const permission = customer.customer_details?.permission
  const isPurchase = Boolean(permission?.find(c => c.module_name?.toLowerCase()?.split(" ")?.join("_") === "purchase_order"))
  const purchasePermission = permission?.filter(c => c.module_name?.toLowerCase()?.split(" ")?.join("_") === "purchase_order")
  const user_type = Number(customer.customer_details?.user_type)
  const purchaseGrant = {
    isView: user_type !== 1 ? Boolean(Number(isPurchase && purchasePermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "purchase_order")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(isPurchase && purchasePermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "purchase_order")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(isPurchase && purchasePermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "purchase_order")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(isPurchase && purchasePermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "purchase_order")?.delete)) : true,
    isImport: user_type !== 1 ? Boolean(Number(isPurchase && purchasePermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "import")?.is_action)) : true,
    isExport: user_type !== 1 ? Boolean(Number(isPurchase && purchasePermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "export")?.is_action)) : true,
  }

  // common advance filter api calls that will be needed everywhere
  const { leadOwner, company, contacts } = useCommonData({
    leadOwner: true,
    leadSource: false,
    companies: true,
    contacts: true
  })

  // heading filter dropdown static options
  const purchaseStaticListOptions = [
    {
      key: "All Purchase Orders",
      icon: <FontAwesomeIcon
        icon={faUser}
        style={{ width: "13px", height: "13px", marginRight: "9px" }}
      />
    }
  ]

  const purchaseImportFields = [
    { id: "contact_name", label: "Contact Name", required: true },
    { id: "reference", label: "Reference", required: true },
    { id: "po_date", label: "Order Date", required: true },
    { id: "delivery_date", label: "Delivery Date", required: true },
    { id: "owner", label: "Owner", required: true },
    { id: "gst_no", label: "GSTN", required: false },
    { id: "description", label: "Short Description", required: true },
    { id: "product_services", label: "Product & Services", required: true },
    { id: "quantity", label: "Quantity", required: true },
    { id: "product_description", label: "Product Description", required: false },
    { id: "rate", label: "Rate", required: true },
    { id: "gst", label: "GST(%)", required: true },
    { id: "discount_type", label: "Discount Type", required: false },
    { id: "discount", label: "Discount", required: false },
    { id: "discount_amount", label: "Amount", required: true },
    { id: "sub_total", label: "Sub Total", required: true },
    { id: "grand_total", label: "Grand Total", required: true },
    { id: "special_discount", label: "Special Discount", required: false },
    { id: "special_discount_type", label: "Special Discount Type", required: false },
    { id: "special_discount_amount", label: "Special Discount Amount", required: false },
    { id: "gst_amount", label: "GST Amount", required: false },
    { id: "customer_note", label: "Customer Notes", required: false },
    { id: "terms_condition", label: "Terms & Conditions", required: false },
    { id: "billing_address", label: "Billing Address", required: false },
    { id: "billing_country", label: "Billing Country", required: false },
    { id: "billing_state", label: "Billing State", required: false },
    { id: "billing_city", label: "Billing City", required: false },
    { id: "billing_zipcode", label: "Billing Zipcode", required: false },
    { id: "shipping_address", label: "Shipping Address", required: false },
    { id: "shipping_country", label: "shipping Country", required: false },
    { id: "shipping_state", label: "shipping State", required: false },
    { id: "shipping_city", label: "shipping City", required: false },
    { id: "shipping_zipcode", label: "shipping Zipcode", required: false },
  ]
  // filter dropdown options
  const dropdownOptions = [
    { value: "reference_number", label: "Reference Number" },
    { value: "contact_id", label: "Contact", option: contacts },
    { value: "owner_id", label: "Owner", option: leadOwner },
    { value: "po_number", label: "Purchase Number" },
    { value: "company_id", label: "Company Name", option: company },
    { value: "delivery_date", label: "Delivery Date", type: "date-range" },
    { value: "created_at", label: "Created at", type: "date-range" },
  ]

  // sub filter dropdown option
  const subFilter = [
    { value: "equals", label: "Equals" },
    { value: "not_equals", label: "Not-Equals" },
    { value: "contains", label: "Contains" },
    { value: "not_contains", label: "Not-Contains" },
    { value: "in", label: "In" },
    { value: "not_in", label: "Not-In" },
    { value: "is_empty", label: "Is Empty" },
    { value: "is_not_empty", label: "Is Not Empty" },
    { value: "begins_with", label: "Begins With" },
    { value: "between", label: "Between" },
  ]
  const customSubFilter = [
    { value: "equals", label: "Equals" },
    { value: "not_equals", label: "Not-Equals" },
    { value: "is_set", label: "Is Set" },
    { value: "is_not_set", label: "Is Not Set" },
    { value: "in", label: "In" },
    { value: "not_in", label: "Not-In" },
  ]

  // Debounced search effect
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setSearch(inputSearch.trim())
      setActiveOffset(0)
    }, 300)
    return () => clearTimeout(debounceTimer)
  }, [inputSearch])

  // edit handler for filter heading
  const handleFilterEdit = async () => {
    try {
      if (editValue === "") return
      if (filterData === null) return
      const updatePayload = {
        customer_id: customer.customer_details?.customer_id,
        user_login_id: customer.customer_details?.id,
        filter_id: filterData.id,
        card_name: editValue,
        description: "",
      }
      const res = await PutRequest(
        "contacts/updateFilterName",
        updatePayload,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      )
      if (res.status === false || res.success === "fail") {
        setFilterDropdown(false)
        return
      }
      if (res.status === "success") {
        setEditingId(null)
        fetchFilterCardCategories()
        setFilterDropdown(false)
      }
    } catch (error) {
      toast.error("Error Updating Filter")
    }
  }
  // delete handler for filter delete
  const handleFilterDelete = async () => {
    setLoading(true)
    try {
      if (filterData === null) return
      const res = await DeleteRequest(
        `common/deleteFilter/${filterData.id}`,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      )
      if (res.status === "fail") {
        toast.error(res.message)
        return
      }
      if (res.success === false) {
        toast.error(res.message)
      }
      setLoading(false)
      setFilterDropdown(false)
      setFilterDelete(false)
      setHeading("All Purchase Orders")
      fetchFilterCardCategories()
      localStorage.setItem("purchase_last_heading", "All Purchase Orders")
      toast.success(res.message)
    } catch (error) {
      toast.error("Error Deleting Filter")
    }
  }

  // to reset the data if tempFilterData i.e if no data exist after doing apply filters in advanced searching logic
  useEffect(() => {
    if (tempFilterData !== null) {
      setActiveOffset(0)
    }
  }, [tempFilterData])

  const handleFilterPageChange = (newOffset) => {
    setFilterOffset(newOffset.selected)
  }

  const dataToDisplay =
    tempFilterData !== null ? tempFilterData : currData;

  const isFiltered = tempFilterData !== null;
  const pageCount = Math.ceil(
    (isFiltered
      ? (dataToDisplay?.length || 0)
      : (total_count || 0)
    ) / limit
  );

  const [endpoint, setEndpoint] = useState("")
  const [queryKey, setQueryKey] = useState("")
  // delete modal open close state
  const [showDeleteModal, setShowDeleteModal] = useState(false)


  const [po_id, setPoId] = useState("")

  // useeeffect for fetching the created advance filters
  const fetchFilterCardCategories = async () => {
    try {
      const res = await GetRequest(
        `common/fetchFilterCard/${customer.customer_details?.customer_id}/purchase_order?offset=${filterOffset}&limit=${filterLimit}&search=${debouncedFilterSearch}`,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      )

      if (res.status === "fail" || res.success === false) {
        return
      }

      setFilterCategories(res.data)

      // Calculate page count if total_count is available in response
      if (res.total_count) {
        setFilterPageCount(Math.ceil(res.total_count / filterLimit))
      }
    } catch (error) {
      toast.error("Error fetching filters")
    }
  }
  useEffect(() => {
    fetchFilterCardCategories()
  }, [])

  useEffect(() => {
    const fetchApprovalCount = async () => {
      try {
        const res = await GetRequest(
          `purchase/fetchMyApprovals/${customerId}/${loginUserId}`,
          { headers },
          extras
        )
        if (res && res.data) {
          // Assuming res.total_count exists or using array length
          const count = res.total_count || res.data.length || 0
          setApprovalCount(count)
        }
      } catch (e) {
        console.error("Error fetching approval count", e)
      }
    }
    fetchApprovalCount()
  }, [])

  useEffect(() => {
    const lowerHeading = heading
      ? heading?.toLowerCase()?.split(" ").join("_")
      : heading
    if (isMyApproval) {
      setEndpoint(`purchase/fetchMyApprovals/${customerId}/${loginUserId}`)
      setQueryKey(`fetchApprovalPurchaseOrder`)
    } else if (lowerHeading === "all_purchase_orders") {
      setEndpoint(
        `purchase/fetchPurchaseOrder/${customerId}/${customer.customer_details?.id}/${customer?.customer_details?.user_type}`
      )
      setQueryKey(`fetchPurchaseOrders`)
    } else {
      // Set for filtered category
      const matchedCategory = filterCategories.find(
        (category) => category.card_name === heading
      )
      if (matchedCategory) {
        setEndpoint(
          `purchase/fetchPurchaseOrder/${customer_id}/${customer?.customer_details?.id}/${customer?.customer_details?.user_type}/${matchedCategory.id}`
        )
        setQueryKey(
          `filterQuery${matchedCategory.card_name
            .toLowerCase()
            ?.split(" ")
            .join("_")}`
        )
      }
    }
  }, [heading, filterCategories, isMyApproval])



  // Single useGetRequest call
  const {
    data: purchaseData,
    refetch: fetchPO,
    isLoading,
  } = useGetRequest(
    endpoint,
    queryKey,
    headers,
    { customer, setCustomer, rf: headers.Authentication, navigate },
    params
  )

  useEffect(() => {
    if (endpoint && queryKey) {
      fetchPO();
    }
  }, [isMyApproval, endpoint]);
  // storing all contacts to a state to use it in the custom dropdown for the dynamic fields
  useEffect(() => {
    if (
      purchaseData &&
      purchaseData.filter_data &&
      purchaseData.filter_data[0] &&
      purchaseData.filter_data[0].filter_values
    ) {
      const values = purchaseData.filter_data[0].filter_values
      const parsedState = JSON.parse(values)
      const filteredArray = parsedState?.map((state) => {
        const dropdownOption = dropdownOptions.find(
          (opt) => opt.value === state.label_name
        )

        let mappedOptions = null
        if (dropdownOption?.option && Array.isArray(dropdownOption.option)) {
          if (dropdownOption.value === "owner_id") {
            mappedOptions = dropdownOption.option.map((opt) => ({
              value: opt.id,
              label: opt.leadName,
            }))
          } else if (dropdownOption.value === "company_id") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.id,
              label: opt.company_name,
            }))
          } else if (dropdownOption.value === "contact_id") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.contactId,
              label: opt.contact_name,
            }))
          } else if (dropdownOption.value === "deal_id") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.id,
              label: opt.deal_name + " " + `(${opt.deal_no})`,
            }))
          }
        }
        return {
          id: state.label_name,
          field: state.label_name, // This is the internal identifier (e.g., "email", "owner")
          label_name: dropdownOption ? dropdownOption.label : state.label_name,
          option: mappedOptions,
          subFilterType: state.label_query,
          value:
            state.label_query === "between"
              ? { start: state.label_value[0], end: state.label_value[1] }
              : state.label_value,
        }
      })

      setFilterState(filteredArray)
    } else {
      setFilterState([])
    }

    setCurrData(purchaseData?.data)
    setTotalCount(purchaseData?.["total_count"])
  }, [queryKey, purchaseData, isMyApproval])

  // Function to handle navigation to detail page
  const handleNavigateToDetail = (orderId) => {
    if (isMyApproval) {
      navigate(`/purchaseDetail/${orderId}/my_approvals`);
    } else {
      navigate(`/purchaseDetail/${orderId}/all_purchase_orders`);
    }
  };

  const columnOptions = [
    { key: "po_number", label: "PO Number", mandatory: true },
    { key: "contact_full_name", label: "PO To" },
    { key: "company_name", label: "Company Name" },
    { key: "owner_full_name", label: "PO Generated By" },
    { key: "po_date", label: "Issued Date" },
    { key: "po_status", label: "Status" },
  ];

  // Initialize columns for the table - ALL columns visible by default
  const [columns, setColumns] = useState(() => {
    const saved = localStorage.getItem("visiblePurchaseColumns");
    const allColumnKeys = columnOptions.map(col => col.label);
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.error("Error parsing visible columns:", e);
      }
    }
    return allColumnKeys;
  });



  const handleConfirmDelete = async () => {
    setLoading(true)
    try {
      const res = await DeleteRequest(
        `purchase/deletePurchaseOrder/${po_id}/${loginUserId}`,
        { headers },
        extras
      )
      if (res.status === "fail" || res.success === false) {
        return
      }
      setLoading(false)
      toast.success(res.message)
      fetchPO()
      setShowDeleteModal(false)
    } catch (error) {
      console.error("error deleting purchase order")
      return
    }
  }

  const handlePageChange = (selectedItem) => {
    setActiveOffset(selectedItem.selected)
  }

  // if no view permission then user should see an authorization card
  if (!purchaseGrant?.isView) {
    return <AuthorizationCard></AuthorizationCard>
  }
  return (
    <>
      <div className="my-4 py-3 pb-1 d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-2">
          <h3
            className="mb-0 d-flex gap-2 align-items-center"
            style={
              isMyApproval
                ? {
                  cursor: "pointer",
                  fontWeight: 300,
                  fontSize: "22px",
                  color: "rgb(154 170 183)",
                }
                : {
                  whiteSpace: "nowrap",
                  fontWeight: 300,
                  fontSize: "22px",
                  cursor: "pointer",
                  color: "#4dabf4",
                }
            }
            onClick={() => setMyApproval(false)}
          >
            {lastHeading !== null && lastHeading !== undefined
              ? lastHeading
              : "All Purchase Orders"}
          </h3>

          <ManageListDropdown
            heading={heading}
            setHeading={setHeading}
            categories={filterCategories}
            storageKey="purchase_last_heading"
            setTempFilterData={setTempFilterData}
            onEdit={(c) => setFilterData(c)}
            onDelete={(c) => {
              setFilterData(c)
              setFilterDelete(true)
            }}
            onUpdate={(c) => {
              setFilterData(c)
              handleFilterEdit()
            }}
            staticOptions={purchaseStaticListOptions}
            filterOffset={filterOffset}
            setFilterOffset={setFilterOffset}
            handleFilterPageChange={handleFilterPageChange}
            filterPageCount={filterPageCount}
            filterLimit={filterLimit}
          />

          <p
            style={{ width: 1, height: 25, background: "lightblue" }}
            className="mb-0"
          ></p>
          <span
            role="button"
            tabIndex={0}
            style={
              isMyApproval
                ? {
                  whiteSpace: "nowrap",
                  fontWeight: 300,
                  cursor: "pointer",
                  color: "#4dabf4",
                }
                : {
                  cursor: "pointer",
                  fontWeight: 300,
                  color: "rgb(154 170 183)",
                }
            }
            onClick={() => setMyApproval((prev) => !prev)}
          >
            <span style={{ fontSize: "20px" }}>My Approvals</span>{" "}
            {approvalCount >= 0 && (
              <>
                {/* Notification Bell Container */}
                <div
                  className="position-relative d-inline-flex align-items-center justify-content-center"
                  style={{ cursor: "pointer" }}
                >
                  {/* The Bell Icon */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="#656565"
                    style={{ width: "20px", height: "20px" }}
                  >
                    <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
                  </svg>

                  {/* The Count Badge */}
                  {approvalCount >= 0 && (
                    <span
                      className="badge rounded-pill bg-success d-flex align-items-center justify-content-center"
                      style={{
                        position: "absolute",
                        top: "-9px",
                        right: "-7px",
                        fontSize: "7px",
                        minWidth: "16px",
                        height: "16px",
                        padding: "0 4px",
                        border: "1px solid white",
                      }}
                    >
                      {approvalCount}
                    </span>
                  )}
                </div>
              </>
            )}
          </span>

          {confirmFilterDelete && (
            <DeleteModal
              show={confirmFilterDelete}
              onClose={() => setFilterDelete(false)}
              onConfirm={() => handleFilterDelete(filterData)}
              isLoading={loading}
              message="Are you sure you want to delete this item?"
            ></DeleteModal>
          )}
        </div>
        <div
          className="d-flex align-items-center gap-1"
          style={{ height: "35px" }}
        >
          <div className="position-relative">
            <input
              type="text"
              style={{ fontSize: "12px", paddingLeft: "36px", height: "35px" }}
              className="form-control"
              value={inputSearch}
              onChange={(e) => {
                setInputSearch(e.target.value)
                setActiveOffset(0)
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault()
                  setSearch(inputSearch)
                  setActiveOffset(0)
                }
              }}
            />
            <i
              class="fa-solid fa-magnifying-glass"
              style={{
                position: "absolute",
                marginTop: "-26px",
                zIndex: 1,
                marginLeft: "13px",
              }}
            ></i>
            {inputSearch.length > 0 && (
              <i
                class="fa-solid fa-xmark"
                style={{
                  position: "absolute",
                  marginTop: "-26px",
                  zIndex: 1,
                  right: 0,
                  marginRight: "13px",
                  cursor: "pointer",
                }}
                onClick={() => setInputSearch("")}
              ></i>
            )}
          </div>
          {/* advance filtering */}
          <Filter
            canEdit_canDownload={true}
            filterDropdown={filterDropdown}
            setFilterDropdown={setFilterDropdown}
            dropdownOptions={dropdownOptions}
            filterState={filterStates}
            setFilterState={setFilterState}
            setHeading={setHeading}
            subFilter={subFilter}
            module_name={"purchase_order"}
            customSubFilter={customSubFilter}
            setTempFilterData={setTempFilterData}
            filterEndpoint={"common/filterQuery"}
            applyQuery={"purchase/applyFilter"}
            view={"list"}
          ></Filter>


          <ColumnConfigurator
            columnOptions={columnOptions}
            columns={columns}
            setColumns={setColumns}
            storageKey="purchaseColumns"
            visibleKey="visiblePurchaseColumns"
          />
          <Dropdown
            as="div"
            className="dropdownsWithoutToggle"
            style={{ zIndex: 101 }}
          >
            <Dropdown.Toggle as={Nav.Link} className="header-link">
              <button
                className="py-2 w-[30px] d-flex gap-1 rounded-1 btn-default-outline justify-content-center"
                style={{
                  fontSize: "1rem",
                  alignItems: "center",
                  height: "35px",
                  width: "2.5rem",
                }}
              >
                {" "}
                <FontAwesomeIcon
                  style={{
                    width: "15px",
                    height: "15px",
                  }}
                  icon={faEllipsisVertical}
                />
              </button>
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="defaultDropdown dropdown-menu-end "
              style={{ width: "11rem", padding: "12px 0px", right: "3.4rem" }}
            >
              <Dropdown.Item
                onClick={() => {
                  if (!purchaseGrant?.isImport) {
                    toast.warning("You are not authorized for this action!");
                    return;
                  }
                  navigate("/importdata", {
                    state: {
                      module_name: "purchase",
                      fieldData: [
                        {
                          title: "General Fields",
                          fields: purchaseImportFields.map((c) => c),
                        },
                      ],
                    },
                  });
                }}
                href="#" className="d-flex align-items-center">
                <FontAwesomeIcon
                  icon={faFileImport}
                  style={{
                    width: "16px",
                    height: "16px",
                    marginRight: "9px",
                    color: "#5e5f60",
                  }}
                />{" "}
                Import Data
              </Dropdown.Item>
              <Dropdown.Item
                className="d-flex align-items-center"
                onClick={() => {
                  if (!purchaseGrant?.isExport) {
                    toast.warning("You are not authorized for this action")
                    return
                  }
                  handleExportData([], "purchase_order", headers, extras)
                }
                }
              >
                <FontAwesomeIcon
                  icon={faFileExport}
                  style={{
                    width: "16px",
                    height: "16px",
                    marginRight: "9px",
                    color: "#5e5f60",
                  }}
                />{" "}
                Export Data
              </Dropdown.Item>
              <Dropdown.Item href="#" className="d-flex align-items-center">
                <FontAwesomeIcon
                  icon={faFileCsv}
                  style={{
                    width: "16px",
                    height: "16px",
                    marginRight: "9px",
                    color: "#5e5f60",
                  }}
                />{" "}
                Template
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <Button
            type="button"
            className="btn btn-default"
            onClick={() => {
              if (!purchaseGrant?.isCreate) {
                toast.warning("You are not authorized for this action")
                return
              }
              navigate(`/createPurchaseOrder/null`)
            }}
            style={{
              maxHeight: "33px",
              color: "white",
              fontSize: "14px",
              border: "1px solid",
              alignItems: "center",
              paddingRight: "10px",
              backgroundColor: "rgb(122, 58, 94)",
            }}
          >
            <FontAwesomeIcon icon={faPlus} /> Add
          </Button>
        </div>
      </div>

      <Container
        fluid
        style={{
          fontFamily: "'Poppins', sans-serif",
          height: "calc(100vh - 12rem)",
          backgroundColor: "white",
          padding: 0,
          animation: "cardEntry 1s ease-out forwards",
        }}
        className="mt-3 p-0"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
          }}
        >
          <div
            className="listStyleForContact container-table"
            style={{
              flex: dataToDisplay?.length > 10 ? 1 : "auto",
              overflow: "auto",
              width: "100%",
              maxHeight: dataToDisplay?.length > 10 ? "100%" : "auto",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.scrollbarColor = "#e0e0e0 white"
            }}
          >
            <Table
              style={{
                width: "100%",
                tableLayout: "auto",
                backgroundColor: "white",
                marginBottom: "0px",
                borderCollapse: "separate",
                borderSpacing: "0px",
              }}
            >
              <thead
                style={{
                  // position: "sticky",
                  top: 0,
                  backgroundColor: "white",
                  zIndex: 10,
                }}
              >
                <tr style={{ textAlign: "start" }}>
                  <th>#</th>
                  {columns.map((col, index) => (
                    <th key={`header-${index}`}>{col}</th>
                  ))}
                  {/* <th
                        className="lastactionTd"
                        style={{
                          ...styles.lastdStyle,
                          position: "sticky",
                          right: 0,
                          backgroundColor: "white",
                          zIndex: 11,
                        }}
                      ></th> */}
                  {!isMyApproval && <th key="actions-header"></th>}
                </tr>
              </thead>
              {/* {isLoading ? <TableSkeleton columnCount={columns.length + 2} /> :
                <>
                  {dataToDisplay !== null && dataToDisplay?.length !== 0 ? (
                    
                  )
                  }
                </> */}
              {
                isLoading ? <TableSkeleton columnCount={columns?.length + 2} /> :
                  <tbody style={{ textAlign: "start" }} className="position-relative">
                    {dataToDisplay !== null && dataToDisplay?.length !== 0 ?
                      <>
                        {dataToDisplay?.map((order, index) => (
                          <tr
                            key={order.id}
                            style={{
                              marginTop: "10px",
                              marginBottom: "10px",
                            }}
                          >
                            <td>{limit * activeOffset + 1 + index}</td>

                            {/* Dynamic cells based on columns order */}
                            {columns.map((col, cellIndex) => {
                              switch (col) {
                                case "PO Number":
                                  return (
                                    <td
                                      key={`cell-${index}-${cellIndex}`}
                                      onClick={() => handleNavigateToDetail(order.id)}
                                      className="text-primary"
                                      style={{ cursor: "pointer" }}
                                    >
                                      {order?.po_number || "-"}
                                    </td>
                                  );

                                case "PO To":
                                  return (
                                    <td key={`cell-${index}-${cellIndex}`}>
                                      {order?.contact_full_name || "-"}
                                    </td>
                                  );

                                case "Company Name":
                                  return (
                                    <td key={`cell-${index}-${cellIndex}`}>
                                      {order.company_name || "-"}
                                    </td>
                                  );

                                case "PO Generated By":
                                  return (
                                    <td
                                      key={`cell-${index}-${cellIndex}`}
                                      style={{
                                        fontWeight: "600",
                                        width: "16% auto",
                                        textTransform: "capitalize",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      {order?.owner_full_name || "-"}
                                    </td>
                                  );

                                case "Issued Date":
                                  return (
                                    <td key={`cell-${index}-${cellIndex}`}>
                                      {order?.po_date
                                        ? (() => {
                                          const today = new Date();
                                          const expiry = new Date(order?.po_date);
                                          let bgColor = "";
                                          if (expiry < today) bgColor = "#f8d3d5";
                                          else if (expiry > today) bgColor = "#c0f7b8";
                                          else bgColor = "#f9f0ce";

                                          return (
                                            <span
                                              style={{
                                                display: "inline-block",
                                                backgroundColor: bgColor,
                                                color: "#444040",
                                                padding: "0px 6px",
                                                borderRadius: "20px",
                                                fontSize: "12px",
                                                fontWeight: "400",
                                              }}
                                            >
                                              {formatDate(order?.po_date)}
                                            </span>
                                          );
                                        })()
                                        : "-"}
                                    </td>
                                  );

                                case "Status":
                                  return (
                                    <td
                                      key={`cell-${index}-${cellIndex}`}
                                      style={{ textTransform: "capitalize", position: "static" }}
                                    >
                                      <span
                                        style={{
                                          textTransform: "capitalize",
                                          color:
                                            order?.po_status === "pending"
                                              ? "#a28414"
                                              : order?.po_status === "draft"
                                                ? "#1f7a96"
                                                : order?.po_status === "cancel"
                                                  ? "#9e1920"
                                                  : order?.po_status === "approved"
                                                    ? "#239b11"
                                                    : order?.po_status === "reject"
                                                      ? "#4f575b"
                                                      : "#999",
                                          borderRadius: "12px",
                                          padding: "1.5px 6px",
                                          backgroundColor:
                                            order?.po_status === "pending"
                                              ? "#f9f0ce"
                                              : order?.po_status === "draft"
                                                ? "#ceecf5"
                                                : order?.po_status === "cancel"
                                                  ? "#f8d3d5"
                                                  : order?.po_status === "approved"
                                                    ? "#c0f7b8"
                                                    : order?.po_status === "reject"
                                                      ? "#d2d6d8"
                                                      : "#999",
                                        }}
                                      >
                                        {order?.po_status || "N/A"}
                                      </span>
                                    </td>
                                  );

                                default:
                                  return <td key={`cell-${index}-${cellIndex}`}>-</td>;
                              }
                            })}

                            {/* Actions column */}
                            {(order?.po_status === "approved" || isMyApproval) ? "" : (<td
                              key={`actions-${index}`}
                              className="lastactionTd"
                              style={{
                                ...styles.lastdStyle,
                                position: "sticky",
                                right: 0,
                                backgroundColor: "white",
                              }}
                            >
                              <div className="endTdDiv">
                                <Dropdown
                                  as="div"
                                  style={{ paddingRight: "0.5rem" }}
                                  className="dropdownsWithoutToggle"
                                >
                                  <Dropdown.Toggle as={Nav.Link} className="header-link">
                                    <FontAwesomeIcon
                                      icon={faEllipsisVertical}
                                      style={{
                                        fontSize: "15px",
                                        width: "20px",
                                        color: "#536485",
                                      }}
                                    />
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu
                                    align={"end"}
                                    style={{
                                      width: "8rem",
                                      inset: "0px auto auto 0px",
                                      boxShadow: "rgb(215, 215, 215) 0px 0px 15px",
                                      position: "absolute",
                                      marginTop: "-22px",
                                      marginRight: "25px",
                                      zIndex: "100",
                                      minWidth: "3rem",
                                    }}
                                  >
                                    <Dropdown.Item
                                      style={{
                                        fontSize: "12px",
                                        padding: "4px 21px",
                                      }}
                                      className="d-flex align-items-center btn"
                                      onClick={(e) => {
                                        if (!purchaseGrant?.isEdit) {
                                          toast.warning("You are not authorized for this action!")
                                          return
                                        }
                                        e.stopPropagation()
                                        navigate(`/createPurchaseOrder/${order.id}`)
                                      }}
                                    >
                                      Edit
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      style={{
                                        fontSize: "12px",
                                        padding: "4px 21px",
                                      }}
                                      className="d-flex align-items-center btn"
                                      onClick={(e) => {
                                        if (!purchaseGrant?.isDelete) {
                                          toast.warning("You are not authorized for this action!")
                                          return
                                        }
                                        e.stopPropagation()
                                        setShowDeleteModal(true)
                                        setPoId(order?.po_id)
                                      }}
                                    >
                                      Delete
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </td>)}

                          </tr>
                        ))}
                        {dataToDisplay?.length > 10 && (
                          <tr>
                            <td colSpan={12}>
                              <div style={{ padding: 0 }}>
                                <div
                                  className="d-flex justify-content-between align-items-center gap-2 mt-2"
                                  style={{
                                    padding: "0.5rem 0",
                                  }}
                                >
                                  <div className="pagination-left">
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontSize: "14px",
                                        paddingRight: "10rem",
                                      }}
                                    >
                                      {/* Showing {offset + 1} of{" "} */}
                                      Showing {activeOffset + 1} of {" "}
                                      {pageCount !== 0
                                        ? pageCount
                                        : pageCount + 1}
                                    </p>
                                  </div>
                                  <div className="pagination-right d-flex gap-2 align-items-center">
                                    <select
                                      style={{
                                        minWidth: "78px",
                                        height: "2.3rem",
                                      }}
                                      onChange={(e) => {
                                        setLimit(Number(e.target.value))
                                        setActiveOffset(0)
                                      }}
                                      id="limit"
                                      className="form-control form-select"
                                    >
                                      <option value={25}>25</option>
                                      <option value={100}>100</option>
                                      <option value={200}>200</option>
                                      <option value={300}>300</option>
                                    </select>
                                    <div className="d-flex align-items-center gap-3">
                                      <Pagination
                                        offset={activeOffset}
                                        setOffset={setActiveOffset}
                                        handlePageChange={handlePageChange}
                                        pageCount={pageCount}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                      </>
                      :
                      <div
                        class="d-flex justify-content-center align-items-center"
                        style={{ position: "absolute", left: "45%" }}
                      >
                        <img
                          src={nodata}
                          alt=""
                          style={{ width: "17rem", marginTop: "0" }}
                        />
                      </div>
                    }
                  </tbody>
              }
            </Table>
          </div>
          {dataToDisplay?.length <= 10 && (
            <div
              style={{
                padding: "0.5rem 0",
                backgroundColor: "white",
                borderTop: "1px solid #e0e0e0",
                width: "100%",
                overflowX: "auto",
              }}
            >
              <div className="d-flex justify-content-between align-items-center gap-2">
                <div className="pagination-left">
                  <p className="mb-0" style={{ fontSize: "14px" }}>
                    Showing {activeOffset + 1} of{" "}
                    {pageCount !== 0 ? pageCount : pageCount + 1}
                  </p>
                </div>
                <div className="pagination-right d-flex gap-2 align-items-center">
                  <select
                    style={{ minWidth: "78px", height: "2.3rem" }}
                    onChange={(e) => {
                      setLimit(Number(e.target.value))
                      setActiveOffset(0)
                    }}
                    id="limit"
                    className="form-control form-select"
                  >
                    <option value={25}>25</option>
                    <option value={100}>100</option>
                    <option value={200}>200</option>
                    <option value={300}>300</option>
                  </select>
                  <div className="d-flex align-items-center gap-3">
                    <Pagination
                      offset={activeOffset}
                      setOffset={setActiveOffset}
                      handlePageChange={handlePageChange}
                      pageCount={pageCount}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </Container>
      <DeleteModal
        show={showDeleteModal}
        onClose={setShowDeleteModal}
        onConfirm={handleConfirmDelete}
        isLoading={loading}
        message="Are you sure you want to delete this item?"
      ></DeleteModal>
      {
        !isPurchase &&
        <UpgradePlan moduleName="Purchase Order" />
      }
    </>
  )
}

const styles = {
  lastdStyle: {
    padding: "0 !important",
  },
  lastactiontd: {
    padding: "0px !important",
  },
  lastactionTh: {
    padding: "0px !important",
  },
}
